import axios from '@/utils/request'

//获取初始化首页收据
export function initHome(data) {
    return axios.$get("/realEestateFairIndex",data)
}
//加载更多数据
export function loadmore(data) {
    return axios.$get("/realEestateFairVideo",data)
}